import React from "react";
import { Drawer } from "antd";

const ReusableDrawer = ({
    open,
    onClose,
    width = 350,
    placement = "right",
    closable = false,
    title,
    extra,
    children
}) => {
    return (
        <Drawer
            width={width}
            placement={placement}
            closable={closable}
            onClose={onClose}
            open={open}
            title={title}
            extra={extra}
            className="custom-drawer"
        >
            {children}
        </Drawer>
    );
};

export default ReusableDrawer;
